/*
 * @Author: Teemo Ding
 * @Date: 2021-06-22 15:56:47
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-08 16:04:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/DeveloperSetting/CreateAccessModal/index.tsx
 */
import React, { useState, Fragment, useMemo } from 'react';
import { message } from 'antd';

import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { accessKeyDownload, accessKeyClose } from '@/src/request/developer';

import { convertRes2Blob } from 'src/tools/helper';

import css from './css.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const CreateAccessModal = ({ closeModal: onCancel, data }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [close, setClose] = useState<number>(0);
  const [hideSecret, setHideSecret] = useState<boolean>(true);
  const onOk = () => {
    accessKeyDownload(data.uuid).then((data) => {
      convertRes2Blob(data);
      message.success('Download completed！');
      onCancel();
    });
  };
  const onClose = () => {
    accessKeyClose(data.uuid).then(() => onCancel());
  };
  const secretText = useMemo(() => {
    if (data.accessSecret) {
      return (
        <Fragment>
          <span>
            {hideSecret
              ? '************************************'
              : data.accessSecret}
          </span>
          <span
            className={css.visible}
            onClick={() => setHideSecret(!hideSecret)}>
            {hideSecret ? getI18n('general.show') : getI18n('general.show')}
          </span>
        </Fragment>
      );
    } else {
      return '';
    }
  }, [hideSecret, data]);
  return (
    <div className={css.createAccessModal}>
      <TopContainer>
        {close === 0 ? (
          <Fragment>
            <p>{getI18n('storeDeveloperSetting.detail.created')}</p>
            <h3>{getI18n('storeDeveloperSetting.detail.download')}</h3>
            <p className={css.p2}>
              {getI18n('storeDeveloperSetting.detail.protect')}
            </p>
            <ItemWrapper
              title={`${getI18n(
                'storeDeveloperSetting.detail.accessKeyTitle',
              )}:`}>
              {data.title || ''}
            </ItemWrapper>
            <ItemWrapper
              title={`${getI18n('storeDeveloperSetting.detail.accessKeyID')}:`}>
              {data.accessKey || ''}
            </ItemWrapper>
            <ItemWrapper
              title={getI18n('storeDeveloperSetting.detail.secretAccessKey')}>
              {secretText}
            </ItemWrapper>
          </Fragment>
        ) : (
          <p className={css.p2}>
            {getI18n('storeDeveloperSetting.detail.noDownload')}
          </p>
        )}
      </TopContainer>
      <ModalFooter
        onCancel={() => (close === 0 ? setClose(1) : onClose())}
        okText={getI18n('storeDeveloperSetting.detail.downloadKeyFile')}
        onOk={onOk}
      />
    </div>
  );
};

export default CreateAccessModal;
